// admin/store/index.ts — Redux store + typed hooks.
//
// Single store instance for the admin tree (the player tree never sees it —
// AdminApp is wrapped in <Provider> from main.tsx's hostname branch).

import { configureStore } from "@reduxjs/toolkit";
import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
  type TypedUseSelectorHook,
} from "react-redux";
import connection from "./slices/connection";
import dashboard from "./slices/dashboard";
import scenarios from "./slices/scenarios";
import users from "./slices/users";
import events from "./slices/events";
import ideas from "./slices/ideas";
import sfx from "./slices/sfx";

export const store = configureStore({
  reducer: {
    connection: connection.reducer,
    dashboard: dashboard.reducer,
    scenarios: scenarios.reducer,
    users: users.reducer,
    events: events.reducer,
    ideas: ideas.reducer,
    sfx: sfx.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = (): AppDispatch => useReduxDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

// Re-export action creators for convenience.
export const connectionActions = connection.actions;
export const dashboardActions = dashboard.actions;
export const scenariosActions = scenarios.actions;
export const usersActions = users.actions;
export const eventsActions = events.actions;
export const ideasActions = ideas.actions;
export const sfxActions = sfx.actions;
